import React, { useState } from "react";
import Carousel from "./Carousel";

const FAQ_TABS = [
  {
    id: "travel",
    label: "Travel",
    images: [
      "/Images/FAQ/TravelGuide/Travel_Guide_1.png",
      "/Images/FAQ/TravelGuide/Travel_Guide_2.png",
      "/Images/FAQ/TravelGuide/Travel_Guide_3.png",
      "/Images/FAQ/TravelGuide/Travel_Guide_4.png",
      "/Images/FAQ/TravelGuide/Travel_Guide_5.png",
    ],
  },
  {
    id: "outfits",
    label: "Dress Code",
    images: [
      "/Images/FAQ/Outfits/1_Outfits.png",
      "/Images/FAQ/Outfits/2_Guideline.png",
      "/Images/FAQ/Outfits/3_FAQ.png",
      "/Images/FAQ/Outfits/4_Examples.png",
    ],
  },
  {
    id: "events",
    label: "Events",
    images: [
      "/Images/FAQ/Events/Events_1.png",
      "/Images/FAQ/Events/Events_2.png",
      "/Images/FAQ/Events/Events_3.png",
      "/Images/FAQ/Events/Events_4.png",
    ],
  },
  {
    id: "gifts",
    label: "Gifts",
    images: [
      "/Images/FAQ/Gifts/Gifts.png"
    ],
  },
];

export default function FAQSection() {
  const [activeTab, setActiveTab] = useState(FAQ_TABS[0].id);
  const active = FAQ_TABS.find((tab) => tab.id === activeTab) ?? FAQ_TABS[0];

  return (
    <section
      id="faq"
      className="min-h-screen flex flex-col items-center justify-center px-4 py-16 bg-[#FDFBF5]"
    >
      <h2 className="text-3xl mb-6">FAQ</h2>

      <div className="w-full max-w-5xl">
        <div className="flex flex-wrap justify-center rounded-t-2xl bg-[#FDFBF5]">
          {FAQ_TABS.map((tab, index) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              className={`min-w-[80px] md:min-w-[100px] lg:min-w-[120px] px-2 md:px-4 lg:px-6 py-2 lg:py-3 text-xs md:text-sm lg:text-base font-semibold transition focus:outline-none
                ${activeTab === tab.id
                  ? "bg-[#F0E5DC] text-gray-900 border-t border-l border-r border-gray-300 border-b-transparent"
                  : "bg-[#FDFBF5] text-gray-700 border border-gray-300 hover:bg-[#f5efe8]"
                }
                ${index === 0 ? "rounded-tl-xl" : ""}
                ${index === FAQ_TABS.length - 1 ? "rounded-tr-xl" : ""}
              `}
              style={{ marginRight: index < FAQ_TABS.length - 1 ? "-1px" : 0 }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="border border-gray-300 rounded-2xl shadow-lg bg-[#F0E5DC] p-6">
          {active.images.length > 0 ? (
            <Carousel images={active.images} />
          ) : (
            <div className="flex flex-col items-center justify-center py-20">
              <p className="text-lg text-gray-600 mb-4">No images added yet.</p>
              <p className="text-sm text-gray-500">This section will display an image once it&apos;s available.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
